import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/display.css";
import { setupIonicReact } from "@ionic/react";
import React from "react";
import { createRoot } from "react-dom/client";
import { BmiApp, type BmiAppSettings } from "./apps/bmi";
import { SpendTrackApp, type SpendTrackAppSettings } from "./apps/spendtrack";
import "./styles.css";

setupIonicReact({ mode: "ios" });

const defaultMaxMoneyAmount = 9999.99;
const rootElement = document.getElementById("pyeah-root");

if (!rootElement) {
  throw new Error("Could not find Pyeah root element.");
}

function parseMaxMoneyAmount(value: string | undefined) {
  const parsedValue = Number(value);

  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : defaultMaxMoneyAmount;
}

const spendTrackSettings: SpendTrackAppSettings = {
  appSlug: rootElement.dataset.appSlug ?? "spendtrack",
  showDayControls: rootElement.dataset.showDayControls === "true",
  isAuthenticated: rootElement.dataset.isAuthenticated === "true",
  userDisplayName: rootElement.dataset.userDisplayName ?? "",
  applicationTitle: rootElement.dataset.applicationTitle ?? "Pyeah! Spending Tracker",
  maxMoneyAmount: parseMaxMoneyAmount(rootElement.dataset.maxMoneyAmount),
  accountManageUrl: rootElement.dataset.accountManageUrl ?? "/account/manage",
  accountLoginUrl: rootElement.dataset.accountLoginUrl ?? "/account/login",
  portalUrl: rootElement.dataset.portalUrl ?? "/",
  trackerUrl: rootElement.dataset.trackerUrl ?? "/",
  bmiUrl: rootElement.dataset.bmiUrl ?? "/"
};

const bmiSettings: BmiAppSettings = {
  appSlug: rootElement.dataset.appSlug ?? "bmi",
  applicationTitle: rootElement.dataset.applicationTitle ?? "Pyeah! BMI Calculator",
  isAuthenticated: rootElement.dataset.isAuthenticated === "true",
  userDisplayName: rootElement.dataset.userDisplayName ?? "",
  accountManageUrl: rootElement.dataset.accountManageUrl ?? "/account/manage",
  accountLoginUrl: rootElement.dataset.accountLoginUrl ?? "/account/login",
  portalUrl: rootElement.dataset.portalUrl ?? "/",
  trackerUrl: rootElement.dataset.trackerUrl ?? "/",
  bmiUrl: rootElement.dataset.bmiUrl ?? "/"
};

const appSlug = rootElement.dataset.appSlug ?? "spendtrack";
const app = appSlug === "bmi" ? <BmiApp settings={bmiSettings} /> : <SpendTrackApp settings={spendTrackSettings} />;

createRoot(rootElement).render(
  <React.StrictMode>
    {app}
  </React.StrictMode>
);
